export default "__VITE_ASSET__AntYL$3D__"